module.exports = __webpack_public_path__ + "img/_016.7f8232dd.png";